import { COGNITO_ERRORS } from './AppConstant';

// Lambda error code format: LMDAERR:#####
const LAMBDA_ERROR_CODE_PREFIX = 'LMDAERR:';

const recoverableCognitoErrorCodes = [
    40003, 40002, 40001, 
    50007, 50006, 50005, 50004
];
const unrecoverableCognitoErrorCodes = [
    50003, 50002, 50001
];

export const parseError = (exception, page, apiError) => {
    let type = 'metric';
    let code = exception?.code;  // translation key
    let dashboard = null; // SSO Identity Platform Dashboard
    const message = exception?.message || '';
        if (code === 'UserNotFoundException') {
            if (message.indexOf('Invalid Credentials') !== -1) {
                code = 'NotAuthorizedException';
            } else {
                if (page !== 'SignIn') {
                    code = 'migration';
                }
            }
        } else if (code === 'NotAuthorizedException') {
            if (message.indexOf('Password attempts exceeded') !== -1) {
                code = 'NotAuthorizedException.attemptsExceeded';
            }
            if (page === 'ChangePassword') {
                code = 'NotAuthorizedException.changePassword';
            }
            if (message.indexOf('User is disabled') > -1) {
                code = 'NotAuthorizedException.userDisabled';
            }
        } else if (code === 'UsernameExistsException') {
            // USER-3941: exception for existing account is
            //   {__type: "UsernameExistsException", message: "An account with the given email already exists."}
            // Keep type as 'metric' because it is not server error
        } else if (code === 'InvalidParameterException') {
            // Just to break the if..else chain so it avoids default assignment.
        }
        else {
            if (message.indexOf('campaignId should be max') !== -1) {
                code = 'CampaignIdSizeExceeded';
                type = 'error';
            } else if (message.indexOf('partnerId should be max') !== -1) {
                code = 'UserLambdaValidationException.partnerIdLengthExceed';
                type = 'error';
            } else if (message.indexOf('partnerSubId should be max 8') !== -1) {
                code = 'UserLambdaValidationException.partnerSubIdLengthExceed';
                type = 'error';
            } else if (message.indexOf('UserAlreadyExistsException') !== -1) {
                // USER-3368: exception message for legacy user is
                //   "PreSignUp failed with error Given emailId is already taken. (UserAlreadyExistsException)."
                code = 'UsernameExistsException';
            } else if (message.indexOf('Task timed out') !== -1) {
                // USER-3318
                dashboard = 'taskTimedOut';
                code = 'default';
            } else if ((dashboard = _parseCognitoError(exception, recoverableCognitoErrorCodes)) !== null) {
                code = 'default';
            } else if ((dashboard = _parseCognitoError(exception, unrecoverableCognitoErrorCodes)) !== null) {
                code = 'PermanentFailures';
                type = 'error';
            } else if (code === '0000') {
                // USER-4350: change password returns 500 ISE for exceeded limit with misleading error on the page
                if (exception.message.indexOf('LimitExceededException') !== -1) {
                    code = 'ChangePasswordLimitExceededException';
                    type = 'error';
                } else if (exception.message.indexOf('InvalidCredentialException') !== -1) {
                    code = (page === 'ChangePassword') ? 'NotAuthorizedException.changePassword' : 'NotAuthorizedException';
                    type = 'error';
                } else if (exception.message.indexOf('Invalid token') !== -1 || exception.message.indexOf('Validation failed') !== -1) {
                    code = 'UserPasswordServiceException';
                    type = 'error';
                }
                else {
                    dashboard = exception.code;
                    code = 'default';
                }
            } else if (code === '9001') {
                // USER-4470: error message for limit exceed for change password
                code = 'ChangePasswordLimitExceededException';
                type = 'error';
            } else if (code === '9000') {
                if(exception.message.indexOf('Max attempts exceeded') !== -1){
                    code = 'ChangePasswordOldWrongPasswordLimitExceededException';
                    type = 'error';
                } else if (exception.message.indexOf('newPassword length must be between 8 and 99') !== -1) {
                    code = 'ChangePasswordMinimumCharacterException';
                    type = 'error';
                } else if (exception.message.indexOf('Membership Number should be 12 digit number') !== -1) {
                    code = 'InvalidMemebershipNumberException';
                    type = 'error';
                } else if (exception.message.match(/(firstName|lastName|membershipEmail|membershipNumber)/)) {
                    code = 'InvalidInputDetailsException';
                    type = 'error';
                } else if (exception.message.indexOf('Invalid verification code') !== -1) {
                    code = 'InvalidVerificationCode';
                    type = 'error';
                } else if (convertToLowerCaseAndCompare(exception.message, 'The reset password request was already processed recently, please try after sometime')) {
                    code = 'UserResetPasswordProcessedCodeException';
                    type = 'error';
                } else {
                    code = 'UserPasswordServiceInvalidCodeException';
                    type = 'error';
                }
            } else if (code === '3013' && exception.message.indexOf('The number has been already applied for multiple accounts') !== -1) {
                code = 'NumberAlreadyAppliedException';
                type = 'error';
            } else if (code === '3014' && exception.message.indexOf('The membership number has been expired or inactive') !== -1) {
                code = 'ExpiredOrInactiveException';
                type = 'error';
            } else if (code === 'InvalidPasswordException') {
                code = 'InvalidPasswordException';
                type = 'error';
            } else if (code === '3008' || code === '3012') {
                if (exception.message.indexOf('Costco email id already migrated') !== -1) {
                    code = 'CostcoAccountAlreadyTrasferred';
                    type = 'error';
                } else {
                    type = 'error';
                    code = 'AccountAlreadyLinked';
                }
            } else if (code === '6011') {
                if (exception.message.indexOf('No holding bin record found') !== -1) {
                    code = 'CostcoEmailRecognized';
                    type = 'error';
                }
            }
            else if (exception && exception.stack && exception.stack.indexOf('handleSubWindowPostMessages') && page === 'SignInPopUp') {
                code = 'SignInNoRedirectPostMessageFailed';
                type = 'error';
            } else if (apiError) {
                const { code: errorCode , type: errorType } = apiCallErrorHandle(message, code, page, exception);
                type = errorType;
                code = errorCode;
            }
            else {
                dashboard = exception.code;
                code = 'default';
            }
            if (code === 'default') {
                type = 'error';
            }
        }
        // USER-2799: handle error from User Password Service
        if (exception.response && exception.response.data && exception.response.data.message) {
            if (exception.response.data.message.indexOf('InvalidCredentialException') !== -1) {
                code = 'NotAuthorizedException.changePassword';
            } else if (exception.response.data.message.indexOf('Reset password code has expired') !== -1) {
                code = 'UserPasswordServiceException';
            } else if (exception.response.data.message.indexOf('Reset password code is invalid') !== -1) {
                code = 'UserPasswordServiceInvalidCodeException';
            }
        }
        if (exception.response && exception.response.data && exception.response.data.code) {
            if (exception.response.data.code === '2003') {
                if (exception.response.data.message && exception.response.data.message.indexOf('MaxLimitReachedException') !== -1) {
                    code = 'ResetPasswordLimitExceededException';
                }
            }
        }
    return {
        error: getCognitoError(code),
        dashboardCode: dashboard || code,
        code,
        type,
        exception,
    };
}

const convertToLowerCaseAndCompare = (ErrorMessage, actualError) => {
    return ErrorMessage.toLowerCase().trim().includes(actualError.toLowerCase().trim());
}

const apiCallErrorHandle = (message, code, page, exception) => {
    let type = 'metric';
    let dashboard = null; // SSO Identity Platform Dashboard
    // let code = exception.code;  // translation key
    if (convertToLowerCaseAndCompare(message, 'Invalid Credentials')) {
        code = 'NotAuthorizedException';
    } else if (convertToLowerCaseAndCompare(message, 'Password attempts exceeded')) {
        code = 'NotAuthorizedException.attemptsExceeded';
    } else if (page === 'ChangePassword') {
        code = 'NotAuthorizedException.changePassword';
    } else if (convertToLowerCaseAndCompare(message, 'User is disabled')) {
        code = 'NotAuthorizedException.userDisabled';
    } else if (convertToLowerCaseAndCompare(message, 'already exists')) {
        code = 'UsernameExistsException';
    } else if (convertToLowerCaseAndCompare(message, 'Recaptcha verification failed')) {
        code = 'UsernameExistsException';
    } else if (convertToLowerCaseAndCompare(message, 'invalid request')) {
        code = 'default';
    } else if (convertToLowerCaseAndCompare(message, 'reference token expired or invalid')) {
        code = 'default';
    } else if (convertToLowerCaseAndCompare(message, 'Email did not matched')) {
        code = 'amazon_email_not_match';
    } else if (convertToLowerCaseAndCompare(message, 'Could not process your request at the moment, please try again later')) {
        code = 'amazon_unable_to_proceed';
    } else if (convertToLowerCaseAndCompare(message, 'Amazon email already linked with shutterfly account')) {
        code = 'amazon_already_linked';
    } else if (convertToLowerCaseAndCompare(message, 'Native legacy account already present')) {
        code = 'amazon_legacy_present';
    } else if (convertToLowerCaseAndCompare(message, 'Native account already present')) {
        code = 'amazon_native_present';
    } else if (convertToLowerCaseAndCompare(message, 'Amazon email already used for another shutterfly account')) {
        code = 'amazon_already_used';
    } else if (code === 'InvalidParameterException') {
        // Just to break the if..else chain so it avoids default assignment.
    } else {
        if (convertToLowerCaseAndCompare(message, 'campaignId should be max')) {
            code = 'CampaignIdSizeExceeded';
            type = 'error';
        } else if(convertToLowerCaseAndCompare(message, 'partnerId should be max')) {
            code = 'UserLambdaValidationException.partnerIdLengthExceed';
            type = 'error';
        } else if(convertToLowerCaseAndCompare(message, 'partnerSubId should be max 8')) {
            code = 'UserLambdaValidationException.partnerSubIdLengthExceed';
            type = 'error';
        } else if (convertToLowerCaseAndCompare(message, 'timed out')) {
            // USER-3318
            dashboard = 'taskTimedOut';
            code = 'default';
        } else if ((dashboard = _parseCognitoError(exception, recoverableCognitoErrorCodes)) !== null) {
            code = 'default';
        } else if ((dashboard = _parseCognitoError(exception, unrecoverableCognitoErrorCodes)) !== null) {
            code = 'PermanentFailures';
            type = 'error';
        } else if (code === '0000') {
            // USER-4350: change password returns 500 ISE for exceeded limit with misleading error on the page
            if (convertToLowerCaseAndCompare(message, 'Limit Exceeded')) {
                code = 'ChangePasswordLimitExceededException';
                type = 'error';
            } else if (convertToLowerCaseAndCompare(message, 'Invalid Credential')) {
                code = (page === 'ChangePassword') ? 'NotAuthorizedException.changePassword' : 'NotAuthorizedException';
                type = 'error';
            }else if (convertToLowerCaseAndCompare(message, 'Invalid token') || convertToLowerCaseAndCompare(message, 'Validation failed')) {
                code = 'UserPasswordServiceException';
                type = 'error';
            } 
            else {
                dashboard = exception.code;
                code = 'default';
            }
        } else if (code === '10001') {
            if (convertToLowerCaseAndCompare(message, 'Incorrect username or password.') || convertToLowerCaseAndCompare(message, 'UserMigration failed with error user not found.') || convertToLowerCaseAndCompare(message, 'An account with the given email already exists.')) {
                code = 'NotAuthorizedException';
            }
        } else if (code === '9001') {
            // USER-4470: error message for limit exceed for change password
            code = 'ChangePasswordLimitExceededException';
            type = 'error';
        } else if (code === '9000') {
            if(convertToLowerCaseAndCompare(message, 'newPassword length must be between 8 and 99')){
                code = 'ChangePasswordMinimumCharacterException';
                type = 'error';
            } else if (convertToLowerCaseAndCompare(message, 'Membership Number should be 12 digit number')){
                code = 'InvalidMemebershipNumberException';
                type = 'error';              
            } else if (exception.message.match(/(firstName|lastName|membershipEmail|membershipNumber)/)){
                code = 'InvalidInputDetailsException';
                type = 'error';              
            } else if (convertToLowerCaseAndCompare(message, 'Invalid verification code')) {
                code = 'InvalidVerificationCode';
                type = 'error';
            } else if (convertToLowerCaseAndCompare(message, 'The reset password request was already processed recently, please try after sometime')) {
                code = 'UserResetPasswordProcessedCodeException';
                type = 'error';
            } else {
                code = 'UserPasswordServiceInvalidCodeException';
                type = 'error';
            }
        } else if (code === '3013' && convertToLowerCaseAndCompare(message, 'The number has been already applied for multiple accounts')) {
            code = 'NumberAlreadyAppliedException';
            type = 'error';  
        } else if (code === '3014' && convertToLowerCaseAndCompare(message, 'The membership number has been expired or inactive')) {
            code = 'ExpiredOrInactiveException';
            type = 'error';  
        } else if(code === 'InvalidPasswordException') {
            code = 'InvalidPasswordException';
            type = 'error';
        } else if (code === '3008' || code === '3012') {
            if (convertToLowerCaseAndCompare(message, 'Costco email id already migrated')) {
                code = 'CostcoAccountAlreadyTrasferred';
                type = 'error';
            } else {
                type = 'error';
                code = 'AccountAlreadyLinked';
            }
        } else if (code === '6011') {
            if (convertToLowerCaseAndCompare(message, 'No holding bin record found')) {
                code = 'CostcoEmailRecognized';
                type = 'error';
            }
        } else if (code === '13006') {
            if (convertToLowerCaseAndCompare(message, 'unauthorized recaptcha token') || convertToLowerCaseAndCompare(message, 'Authorization failed')) {
                code = 'default';
                type = 'error';
            }
        } else if (exception && exception.stack && exception.stack.indexOf('handleSubWindowPostMessages') && page === 'SignInPopUp') {
            code = 'SignInNoRedirectPostMessageFailed';
            type = 'error';
        } else {
            dashboard = exception.code;
            code = 'default';
        }

        if (code === 'default') {
            type = 'error';
        }
    }
    return { code, type, dashboard };
}


// USER-3689: Signup failure due to network issue
// Example server response:
//   {"__type":"UserLambdaValidationException","message":"PreSignUp failed with error emailId should be max 64 characters in length LMDAERR:40002."}
const _parseCognitoError = (exception, errorCodes) => {
    // const { message } = exception;
    if (exception?.message) {
        const regex = new RegExp(`${LAMBDA_ERROR_CODE_PREFIX}(\\d+)`);
        const found = exception.message.match(regex);
        if (found) {
            const errorCodeStr = found[0].substring(LAMBDA_ERROR_CODE_PREFIX.length);
            const errorCode = parseInt(errorCodeStr, 10);
            if (errorCodes.indexOf(errorCode) !== -1) {
                return `${LAMBDA_ERROR_CODE_PREFIX}${errorCode}`;
            }
        }
    }
    return null;
}

export function getCognitoError(errCode, defaultErrCode) {
    return COGNITO_ERRORS[errCode] || COGNITO_ERRORS[defaultErrCode] || 'errors.cognito.default';
}
